import { styled, Box, Button, createStyles, makeStyles } from '@material-ui/core';
import { MdClear as Clear } from 'react-icons/md';
import { TextInput } from '@room-match/shared-ui-components';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_CONTAINER_BORDER,
  DARK_CONTAINER_FIELDS_ON_CARD,
  DARK_CARDS_BACKGROUND,
  ERROR_ICON,
  LIGHT_CONTAINER_FIELDS_ON_CARD,
  LIGHT_MENUITEM_BACKGROUND,
  PRIMARY_BUTTON_BACKGROUND,
  LIGHT_TEXT_FADED_BORDER,
  LIGHT_CONTAINER_BORDER,
  PRIMARY_BUTTON_BORDER,
  DARK_TOOLTIP_BACKGROUND,
  LIGHT_TOOLTIP_BACKGROUND,
  PLAIN_TEXT,
} = COLORS;

export const MainCont = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_ON_CARD : LIGHT_CONTAINER_FIELDS_ON_CARD,
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  borderRadius: 8,
  padding: 10,

  '& .credit-item-list': {
    '&.disabled-true .drag-icon': {
      opacity: 0.5,
    },

    '& > *:last-child': {
      borderBottom: `2px solid ${DARK_CONTAINER_BORDER}`,
    },
    '&:first-child': {},
  },
}));

export const AddButton = styled(Button)(({ theme }) => ({
  width: 60,
  height: 23,
  border: `1px solid ${PRIMARY_BUTTON_BACKGROUND}`,
  fontSize: 12,
  marginRight: 23,
}));

export const AddMediaButton = styled(Button)(({ theme }) => ({
  width: 150,
  height: 36,
  border: `1px solid ${PRIMARY_BUTTON_BORDER}`,
  background: 'transparent',
  textTransform: 'none',
  transition: 'opacity 0.2s ease',
}));

export const StyledClear = styled(Clear)(({ theme }) => ({
  color: ERROR_ICON,
}));

export const ItemHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
}));

export const NewItemField = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'minmax(0,1fr) minmax(0,1fr) minmax(0,1fr) minmax(0,1fr) auto auto auto',
  borderTop: '2px solid',
  borderColor: theme.palette.type === 'dark' ? LIGHT_TEXT_FADED_BORDER : LIGHT_CONTAINER_BORDER,
  padding: '0 10px',
  margin: '10px 10px -7px 10px',
  alignItems: 'center',
  gap: 10,

  '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input': {
    padding: '0 5px',
  },

  [theme.breakpoints.down(1100)]: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 10px 5px',
    paddingTop: 10,

    '& .MuiFormControl-root': {
      margin: 0,
    },
  },

  [theme.breakpoints.down(700)]: {
    '& > div': {
      width: '100%',
    },
  },
}));

export const CustomTextInput = styled(TextInput)(({ theme }) => ({
  height: 36,
  '& .MuiInputBase-root': {
    backgroundColor: theme.palette.type === 'dark' ? `${DARK_CARDS_BACKGROUND} !important` : LIGHT_MENUITEM_BACKGROUND,
  },
}));

export const ErrorMessageContainer = styled('div')(({ theme }) => ({
  marginTop: -15,
  marginBottom: 5,
  [theme.breakpoints.down(1100)]: {
    margin: 0,
  },
}));

export const SaveButton = styled(Button)(({ theme }) => ({
  backgroundColor: PRIMARY_BUTTON_BACKGROUND,
  color: PLAIN_TEXT,
  height: 36,
  padding: 0,
  '&:hover': {
    backgroundColor: PRIMARY_BUTTON_BACKGROUND,
  },
}));

export const ViewMediaButton = styled(Button)(({ theme }) => ({
  marginLeft: 10,
  border: `1px solid ${PRIMARY_BUTTON_BORDER}`,
  backgroundColor: 'transparent',
  textTransform: 'none',
}));

// New Styles
export const useStyles = makeStyles((theme) =>
  createStyles({
    option: {
      '&:hover': {
        backgroundColor: theme.palette.type === 'dark' ? '' : LIGHT_MENUITEM_BACKGROUND,
      },
      '&[data-focus="true"]': {
        backgroundColor: theme.palette.type === 'dark' ? '' : LIGHT_MENUITEM_BACKGROUND,
      },
    },
    toolTip: {
      background: theme.palette.type === 'dark' ? DARK_TOOLTIP_BACKGROUND : LIGHT_TOOLTIP_BACKGROUND,
    },
  }),
);
